(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/racing-game/assets/javascripts/init.js');

'use strict';

const isMobile = svs.core.detect.formfactor.mobile();
svs.racing_game.data.prevUrl = document.referrer ? new URL(document.referrer) : '';
const {
  RacingRouter
} = svs.racing_game;
const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
const updateColumnSize = () => {
  const leftCol = document.querySelector('#left-column');

  if (!leftCol) {
    return;
  }
  const colHeight = isSelfService ? window.innerHeight - document.querySelector('.js-fixed-top-content').offsetHeight - 120 : window.innerHeight - document.querySelector('.js-fixed-top-content').offsetHeight;
  leftCol.style.height = "".concat(colHeight, "px");
  svs.components.header.on('headerVisibilityChange', visible => {
    if (visible) {
      leftCol.style.height = "".concat(colHeight, "px");
    } else if (svs.core.template.getConfig().hasBalanceBar && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      leftCol.style.height = "".concat(colHeight + 88, "px");
    } else {
      leftCol.style.height = "".concat(colHeight + 44, "px");
    }
  });
};
const setupGameColumnScroll = () => {
  let resizeIndex;
  window.addEventListener('resize', () => {
    clearTimeout(resizeIndex);
    resizeIndex = setTimeout(() => {
      updateColumnSize();
    }, 300);
  });
  updateColumnSize();
  svs.components.header.triggerOnHeaderVisibilityChange(true, ['xs', 'sm']);
};
ReactDOM.render( React.createElement(RacingRouter, null), document.getElementById('racing-wrapper'));
!isMobile && setupGameColumnScroll();

 })(window);